const Responsive_Project = () => {
  return (
    <div>
      <h1>Responsive Project</h1>
    </div>
  );
};
export default Responsive_Project;
